/* ==========================================================================
   SMELLERS · Landing 3 — calculadora de rendimiento + ATC
   Todo se calcula con datos propios: contenido de la botella, la dilución de
   la etiqueta y el precio real de Shopify.
   ========================================================================== */
(function () {
  'use strict';

  var page = document.querySelector('[data-rd-page]');
  if (!page) return;

  var calc = document.querySelector('[data-rd-calc]');

  function money(cents, fmt) {
    var n = cents / 100;
    var m = fmt.match(/\{\{\s*(\w+)\s*\}\}/);
    var kind = m ? m[1] : 'amount';
    var str;
    if (kind.indexOf('no_decimals') > -1) {
      str = Math.round(n).toLocaleString('es-MX');
    } else if (kind === 'amount_with_comma_separator') {
      str = n.toLocaleString('de-DE', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
    } else {
      str = n.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
    }
    return fmt.replace(/\{\{\s*\w+\s*\}\}/, str);
  }

  if (calc) {
    var ml = parseFloat(calc.dataset.ml) || 946;
    var dose = parseFloat(calc.dataset.dose) || 30;
    var price = parseFloat(calc.dataset.price) || 0;
    var fmt = calc.dataset.money || '${{amount}}';

    var input = calc.querySelector('[data-rd-input]');
    var outL = calc.querySelector('[data-rd-litros]');
    var outC = calc.querySelector('[data-rd-cubetas]');
    var outP = calc.querySelector('[data-rd-costo]');

    function run() {
      var cubeta = Math.max(1, Math.min(20, parseFloat(input.value) || 5));
      var litros = ml / dose;
      outL.textContent = Math.floor(litros);
      outC.textContent = Math.floor(litros / cubeta);
      outP.textContent = money(Math.round(price / litros), fmt);
    }

    input.addEventListener('input', run);
    run();
  }

  /* ---------- agregar al carrito ---------- */
  var busy = false;
  function root() {
    return window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/';
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-rd-add]');
    if (!btn || busy) return;
    var id = parseInt(btn.dataset.variant, 10);
    if (!id) return;
    busy = true;
    btn.setAttribute('aria-busy', 'true');

    fetch(root() + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: id, quantity: 1 }] })
    })
      .then(function (r) { return r.json(); })
      .then(function (data) {
        if (data && data.status && data.status !== 200) throw new Error();
        window.location.href = root() + 'cart';
      })
      .catch(function () {
        busy = false;
        btn.removeAttribute('aria-busy');
        var err = document.querySelector('[data-rd-error]');
        if (err) {
          err.hidden = false;
          err.textContent = 'No pudimos agregarlo. Intenta de nuevo o escríbenos por WhatsApp.';
        }
      });
  });

  /* ---------- barra sticky mobile ---------- */
  var dock = document.querySelector('[data-rd-dock]');
  var buy = document.getElementById('rd-comprar');
  if (dock && 'IntersectionObserver' in window) {
    var pastHero = false;
    var buyVisible = false;

    function sync() {
      var show = pastHero && !buyVisible;
      dock.classList.toggle('is-up', show);
      page.classList.toggle('rd--dock-on', show);
    }

    var hero = document.querySelector('.rd__hero');
    if (hero) {
      new IntersectionObserver(function (en) {
        pastHero = !en[0].isIntersecting && en[0].boundingClientRect.top < 0;
        sync();
      }, { threshold: 0 }).observe(hero);
    }
    if (buy) {
      new IntersectionObserver(function (en) {
        buyVisible = en[0].isIntersecting;
        sync();
      }, { threshold: 0.12 }).observe(buy);
    }
  }
})();
